import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';

import { StoreList } from '@/ui/index';

import styles from './AppBanner.module.scss';

export const AppBanner = ({ item }) => {
  const { t } = useTranslation();

  return (
    <div
      className={styles.banner}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles.content}>
        <div className={styles.imageBanner}>
          <Image
            src='/assets/loginApp.svg'
            alt='phone'
            title='phone'
            layout='fill'
            objectFit='contain'
          />
        </div>
        <div className={styles.bottom}>
          <p className={styles.title}>{t('common:Download our app')}</p>
          <p className={styles.subtitle}>{t('common:Download and qr')}</p>
          <div className={styles.store}>
            <StoreList links={item?.links} />
            <div className={styles.image}>
              <Image
                src={item?.qr_image}
                alt='Bakcell app qr-code'
                title='Bakcell app qr-code'
                layout='fill'
                placeholder='blur'
                blurDataURL={item?.qr_image}
                loading='lazy'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
